import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { Link, Text } from 'mdast';

type SerializableSmartLinkData = {
	'@id'?: unknown;
	name?: unknown;
	title?: unknown;
	url?: unknown;
};

const getStringAttr = (value: unknown): string | undefined =>
	typeof value === 'string' && value.length > 0 ? value : undefined;

const getSmartLinkData = (node: PMNode): SerializableSmartLinkData | undefined =>
	typeof node.attrs.data === 'object' && node.attrs.data !== null && !Array.isArray(node.attrs.data)
		? (node.attrs.data as SerializableSmartLinkData)
		: undefined;

const getSmartLinkUrl = (node: PMNode): string => {
	const data = getSmartLinkData(node);
	return (
		getStringAttr(node.attrs.url) ?? getStringAttr(data?.url) ?? getStringAttr(data?.['@id']) ?? ''
	);
};

const getSmartLinkTitle = (node: PMNode, url: string): string => {
	const data = getSmartLinkData(node);
	return getStringAttr(data?.name) ?? getStringAttr(data?.title) ?? url;
};

export function inlineCard(node: PMNode): Link | Text | null {
	const url = getSmartLinkUrl(node);
	if (!url) {
		const title = getSmartLinkTitle(node, url);
		return title ? { type: 'text', value: title } : null;
	}

	return {
		type: 'link',
		url,
		title: null,
		children: [{ type: 'text', value: getSmartLinkTitle(node, url) }],
	};
}
